import React from "react";

// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";

import img from "assets/img/reports.jpg";
import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

const useStyles = makeStyles(styles);

export default function Reports() {
    const classes = useStyles();

    return (
        <div>
            <GridContainer>
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary">
                            <h4 className={classes.cardTitleWhite}>Reports</h4>
                        </CardHeader>
                        <CardBody>
                            <img src={img} alt="report" style={{width: "100%"}} />
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    );
};